




import FlagIcon from '@mui/icons-material/Flag';
import GroupIcon from '@mui/icons-material/Group';
import PeopleIcon from '@mui/icons-material/People';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import ScoreIcon from '@mui/icons-material/Score';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
  Box,
  Divider,
  Grid,
  Paper,
  Skeleton,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';

const formatNumber = (num) => {
  if (num >= 1_000_000) return (num / 1_000_000).toFixed(1) + 'M';
  if (num >= 1_000) return (num / 1_000).toFixed(1) + 'K';
  return num?.toString();
};

const StatisticItem = ({ icon: Icon, label, value }) => (
  <Grid item xs={12} sm={6} md={4}>
    <Paper elevation={3} sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
      <Icon color="primary" />
      <Box>
        <Typography variant="body1">{label}</Typography>
        <Typography variant="h6" fontWeight="bold">{value}</Typography>
      </Box>
    </Paper>
  </Grid>
);
// ssdddaaaaaaaaaaaaaaaaa
const Statistics = ({ instagramURL }) => {
  const [statistics, setStatistics] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!instagramURL) return;

    const fetchStatistics = async () => {
      setLoading(true);
      try {
        const apiResponse = await fetch("https://server-side-influencer.onrender.com/influencer/add-link", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ instaUrl: instagramURL }),
        });

        const apiData = await apiResponse.json();
        if (apiData?.data) {
          setStatistics(apiData.data);
        } else {
          setError("Failed to retrieve statistics.");
        }
      } catch (err) {
        console.error("Error fetching statistics:", err);
        setError("Failed to load statistics.");
      } finally {
        setLoading(false);
      }
    };

    fetchStatistics();
  }, [instagramURL]);

  if (loading) {
    return (
      <Box sx={{ mt: 4, px: 2 }}>
        <Typography variant="h5" fontWeight="bold" mb={2}>
          Instagram Statistics
        </Typography>
        <Grid container spacing={2}>
          {[...Array(6)].map((_, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Paper elevation={3} sx={{ p: 2 }}>
                <Skeleton variant="circular" width={40} height={40} />
                <Skeleton variant="text" width="60%" />
                <Skeleton variant="text" width="40%" />
              </Paper>
            </Grid>
          ))}
        </Grid>
        <Divider sx={{ my: 4 }} />
        <Typography variant="h6" gutterBottom>
          Brand Safety
        </Typography>
        <Grid container spacing={2}>
          {[...Array(3)].map((_, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Paper elevation={3} sx={{ p: 2 }}>
                <Skeleton variant="rectangular" width="100%" height={80} />
              </Paper>
            </Grid>
          ))}
        </Grid>
        <Divider sx={{ my: 4 }} />
        <Typography variant="h6" gutterBottom>
          Audience Demographics
        </Typography>
        <Skeleton variant="text" width="70%" />
        <Divider sx={{ my: 4 }} />
        <Typography variant="h6" gutterBottom>
          Rating Tags
        </Typography>
        <Grid container spacing={1}>
          {[...Array(4)].map((_, index) => (
            <Skeleton key={index} variant="text" width={80} sx={{ m: 1 }} />
          ))}
        </Grid>
      </Box>
    );
  }

  if (error) return <Typography color="error">{error}</Typography>;
  if (!statistics) return null;

  const {
    avgLikes,
    avgViews,
    avgER,
    avgInteractions,
    pctFakeFollowers,
    ratingIndex,
    qualityScore,
    brandSafety,
    ratingTags,
    membersGendersAges,
  } = statistics;

  return (
    <Box sx={{ mt: 4, px: 2 }}>
      <Typography variant="h5" fontWeight="bold" mb={2}>
        Instagram Statistics
      </Typography>

      <Grid container spacing={2}>
        <StatisticItem icon={ThumbUpAltIcon} label="Average Likes" value={formatNumber(avgLikes || 0)} />
        <StatisticItem icon={VisibilityIcon} label="Average Views" value={formatNumber(avgViews || 0)} />
        <StatisticItem icon={PeopleIcon} label="Engagement Rate" value={`${avgER || 0}%`} />
        <StatisticItem icon={GroupIcon} label="Average Interactions" value={formatNumber(avgInteractions || 0)} />
        <StatisticItem icon={PersonOffIcon} label="Fake Followers" value={`${pctFakeFollowers || 0}%`} />
        <StatisticItem icon={ScoreIcon} label="Rating Index" value={ratingIndex?.toFixed(2) || 0} />
        <StatisticItem icon={FlagIcon} label="Quality Score" value={qualityScore?.toFixed(2) || 0} />
      </Grid>

      <Divider sx={{ my: 4 }} />

      <Typography variant="h6" gutterBottom>
        Brand Safety
      </Typography>
      <Grid container spacing={2}>
        {brandSafety &&
          Object.entries(brandSafety).map(([key, value]) => (
            <StatisticItem
              key={key}
              icon={ReportProblemIcon}
              label={key.replace(/_/g, ' ')}
              value={value}
            />
          ))}
      </Grid>

      <Divider sx={{ my: 4 }} />

      <Typography variant="h6" gutterBottom>
        Audience Demographics
      </Typography>
      <Typography variant="body2" mb={1}>
        Male: {membersGendersAges?.summary?.m ?? 'N/A'}%, Female: {membersGendersAges?.summary?.f ?? 'N/A'}%, Avg Age: {membersGendersAges?.summary?.avgAges || '-'}
      </Typography>

      {ratingTags?.length > 0 && (
        <>
          <Divider sx={{ my: 4 }} />
          <Typography variant="h6" gutterBottom>
            Rating Tags
          </Typography>
          <Box>
            {ratingTags.map((tag) => (
              <Paper key={tag.tagID} sx={{ display: 'inline-block', m: 1, p: 1 }}>
                {tag.name}
              </Paper>
            ))}
          </Box>
        </>
      )}
    </Box>
  );
};

export default Statistics;
